import Styles from './Icon.module.scss'
import { IconSizeProps } from 'blaze-ui/icons/Types'

export const Icon = ({ size = 30, icon }: IconSizeProps & { icon: string }) => (
  <span
    style={{
      fontSize: `${size}px`,
      width: `${size}px`,
      height: `${size}px`,
    }}
    className={Styles.icon}
  >
    {icon}
  </span>
)
